import { useEffect, useState } from "react";
import { getAllCountries } from "../../../../service/MainService";

const SimpleCountrySelect = ({ value, onChange }) => {
  const [country, setCountry] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const CountryList = await getAllCountries();
        setCountry(CountryList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);
  return (
    <div>
      <label
        htmlFor="country"
        className="block text-sm font-medium leading-6 text-gray-500"
      >
        Country <span className="text-red-500">*</span>
      </label>
      <select
        as="select"
        value={value}
        onChange={onChange}
        className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
      >
        <option value="" disabled selected>
          Select
        </option>
        {country.map((option) => (
          <option key={option.CountryId} value={option.CountryId}>
            {option.CountryName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SimpleCountrySelect;
